import type { Question } from '../../config/types';

export type EmailQuestion = Pick<
  Question,
  | 'name'
  | 'title'
  | 'description'
  | 'hint'
  | 'rules'
  | 'width'
  | 'textRows'
  | 'characterCount'
  | 'defaultValue'
> & {
  questionType: 'textInput' | 'textarea' | 'radio' | 'checkbox' | 'select' | 'date' | 'content';
  options?: string[];
  showWhen?: { field: string; condition: 'equals'; value: string }[];
};

export type EmailFormConfig = {
  formName: string;
  version: number;
  title: string;
  hint?: string;
  submitText: string;
  confirmationTitle: string;
  confirmationText: string;
  pages: { name: string; title?: string; questions: EmailQuestion[] }[];
};

export type LinkState = {
  status: 'pending' | 'expired' | 'submitted';
  config: EmailFormConfig;
};

export function visibleQuestions(config: EmailFormConfig, values: Record<string, unknown>) {
  const visible: EmailQuestion[] = [];
  const active: Record<string, unknown> = {};
  for (const question of config.pages.flatMap((page) => page.questions)) {
    if (
      !(question.showWhen || []).every((condition) => active[condition.field] === condition.value)
    )
      continue;
    visible.push(question);
    active[question.name] = values[question.name];
  }
  return visible;
}
